import { useId, useLayoutEffect, useRef } from 'react';

function ActionIcon({ kind }) {
    const shapes = {
        event: <path d="M3 6h18M9 6V3h6v3m4 0-1 15H6L5 6m5 4v7m4-7v7" />,
        keep: <><circle cx="9" cy="7" r="4" /><path d="M3 21v-2a6 6 0 0 1 12 0v2m1-9 2 2 4-4" /></>,
        close: <path d="m6 6 12 12M18 6 6 18" />,
    };
    if (!shapes[kind]) return null;
    return <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.7" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true" focusable="false">
        {shapes[kind]}
    </svg>;
}

export default function TemporaryPersonNotice({ notice, onDismiss }) {
    const panel = useRef(null);
    const backdropPressed = useRef(false);
    const titleId = useId();
    const descriptionId = useId();
    useLayoutEffect(() => {
        if (!notice) return;
        const dialog = panel.current;
        const previous = document.activeElement;
        dialog.showModal();
        dialog.querySelector('.temporary-person-cancel')?.focus({ preventScroll: true });
        return () => {
            dialog.close();
            if (previous?.isConnected) previous.focus?.({ preventScroll: true });
        };
    }, [notice]);
    if (!notice) return null;
    const isBackdrop = event => {
        if (event.target !== panel.current) return false;
        const rect = panel.current.getBoundingClientRect();
        return !(event.clientX >= rect.left && event.clientX <= rect.right && event.clientY >= rect.top && event.clientY <= rect.bottom);
    };
    const dismissInHeader = notice.dismissPlacement === 'header';
    const dismissLabel = notice.confirmation ? 'Cancel·lar' : 'Tancar';
    const dismissButton = <button type="button" className="temporary-person-cancel" aria-label={dismissLabel} onClick={onDismiss}>
        <ActionIcon kind="close" />
        {!dismissInHeader && <span>{dismissLabel}</span>}
    </button>;
    return <dialog ref={panel} aria-labelledby={titleId} aria-modal="true" aria-describedby={descriptionId} data-board-confirmation="true"
        className="temporary-person-dialog"
        onCancel={event => { event.preventDefault(); onDismiss(); }}
        onPointerDown={event => { backdropPressed.current = isBackdrop(event); }}
        onClick={event => { if (backdropPressed.current && isBackdrop(event)) onDismiss(); backdropPressed.current = false; }}
        onKeyUp={event => event.stopPropagation()}
        onKeyDown={event => event.stopPropagation()}>
        <div className="temporary-person-heading">
            <h2 id={titleId}>{notice.title || (notice.confirmation ? 'Confirmar el canvi' : 'No s’ha pogut completar')}</h2>
            {dismissInHeader && dismissButton}
        </div>
        <p id={descriptionId}>{notice.message}</p>
        <div className="temporary-person-actions">
            {notice.actions.map(action => <button type="button" className={action.destructive ? 'destructive' : ''} key={action.label} onClick={action.run}>
                <ActionIcon kind={action.icon} />
                <span>{action.label}</span>
            </button>)}
        </div>
        {!dismissInHeader && dismissButton}
    </dialog>;
}
